let portalUrl = '';

export const portalRootUrl = (val?: string) => {
  if (val) portalUrl = val;
  return portalUrl;
};
